import { Directive } from "@angular/core";

@Directive({
	selector: "[tgToolbarControls]",
})
export class TgToolbarControlsDirective {
	constructor() {}
}
